import Vue from 'vue'

export default (context) => {
    const instance = new Security(context);
    Vue.prototype.$security = instance;
    return context.next();
};

const routeOptions = {};

export class Security {
    constructor(ctx) {
        this.ctx = ctx;
        // get all routes options at start
        ctx.router.options.routes.forEach((route) => {
            if (route.path === '/') {
                routeOptions[route.path] = 'ViewLandingPage'
            } else {
                routeOptions[route.path] = route.meta.authorizationKey;
            }
            // routeOptions[route.path] = route.meta.authorizationKey;
        });
    }

    canAccessRoute(path) {
        try {
            let options = null;
            if (typeof (path) === 'string') options = routeOptions[path];
            if (!options) return false;
            return this.checkUserAccess(options)
        } catch (e) {
            console.error(e);
            return false;
        }
    }

    checkUserAccess(routeOrName) {
        const { ctx } = this;
        const permissionsList = ctx.router.app.$auth.permissions
        if (routeOrName === "Allowed" || !sessionStorage.getItem("tenantId")) return true
        if (permissionsList.includes(routeOrName)) return true;
        return false;
    }

    checkMeetingTypeAccess(meetingTypeId, permission) {
        const { ctx } = this;
        const meetingTypePermissions = ctx.router.app.$auth.meetingTypePermissions
        if (meetingTypePermissions[meetingTypeId]) {
            if (meetingTypePermissions[meetingTypeId].includes(permission)) return true;
            return false
        }
        return false
    }
}
